/**
 * Created by meirr on 8/14/16.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseTableViewController = require('web-agent-framework/BaseTableViewController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var MessagingUtils = require('web-agent-utils/MessagingUtils');
    var ConnectionsLogListWidgetsManager = require('web-agent-viewControllers/ConnectionsLogListWidgetsManager');
    var ConnectionsLogEngagementWidget = require('web-agent-widgets/ConnectionsLogEngagementWidget');
    var ConnectionsLogConsumerInfoWidget = require('web-agent-widgets/ConnectionsLogConsumerInfoWidget');
    var ConsumerInfoWidget = require('web-agent-widgets/ConsumerInfoWidget');
    var DurationInputViewController = require('web-agent-viewControllers/DurationInputViewController');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var LEConfig = require("assets/config/le-env-conf");

    var APPLICATION_TYPE = 'ConnectionsLogTableViewController';

    var ConnectionsLogTableViewController = BaseTableViewController.extend({
        DEFAULT_LOADING_TIMEOUT_LIMIT: 900000, // 90 Sec
        ControllerName: "ConnectionsLogTableViewController",
        applicationType: "ConnectionsLogTableViewController",
        LPClassesMap: {
            filterContainer: '.lpView_table_filter_container',
            connectionsLogTable: "connections_log_table",
            manager: "manager",
            agent: "agent",
            agent_view_other: "agent_view_other",
        },
        LPPrefixMap: {
            connectionsLog: "CONNECTIONS_LOG"
        },
        translationTexts: {
            NOT_AVAILABLE: "notAvailable",
            StatusFilterStateOpen: "statusFilterStateOpen",
            StatusFilterStateClose: "statusFilterStateClose",
            StatusFilterStateLocked: "statusFilterStateLocked",
            DeviceFilterStateTablet: "deviceFilterStateTablet",
            DeviceFilterStateDesktop: "deviceFilterStateDesktop",
            DeviceFilterStateMobile: "deviceFilterStateMobile",
            DeviceFilterStateNA: "deviceFilterStateNA",
            SourceFilterStateApp: "sourceFilterStateApp",
            SourceFilterStateWeb: "sourceFilterStateWeb",
            SourceFilterStateAgent: "sourceFilterStateAgent",
            SourceFilterStateSMS: "sourceFilterStateSMS",
            SourceFilterStateFacebook: "sourceFilterStateFacebook",
            conversationInQueueFilter: "conversationInQueueFilter",
            history_search_filter_survey_bot_conversations: "history_search_filter_survey_bot_conversations",
            history_search_filter_invalid_free_text_answer: "history_search_filter_invalid_free_text_answer",
            history_search_filter_open_question_answered: "history_search_filter_open_question_answered",
            history_search_filter_survey_enter_id: "history_search_filter_survey_enter_id",
            unassigned: 'unassigned'
        },

        filterName: "filters",


        LPSearchFilterOptions: {
            TRANSCRIPT: {id: "transcript", text: "history_search_filter_transcripts"},
            CHATID: {id: "chatId", text: "history_search_filter_conversation_ID"}
        },


        initialize: function () {
        },

        events: function () {
            this.bindModel({
                modelPath: this.getConfiguration().tableRootModelPath + ".lastQuery.searchTag",
                callback: this.handleSearchValueChanged
            });
            this.bindModel({
                modelPath: this.getConfiguration().tableRootModelPath + ".lastQuery.searchArea",
                callback: this.handleSearchValueChanged
            });
        },

        render: function () {
            this.addClass(this.view, this.LPClassesMap.connectionsLogTable);
        }
    });

    ConnectionsLogTableViewController.prototype.getModelControllerInstance = function () {
        return lpTag.WebAgent.amsEngagementHistoryController;
    };

    ConnectionsLogTableViewController.prototype.handleSearchValueChanged = function () {
        var mc = this.getModelControllerInstance();
        var filterContainer = this.getFirstElement(this.LPClassesMap.filterContainer);
        if (isConversationMode(mc) && this.filterStatusEnable) {
            this.filterStatusEnable = false;
            this.setFilterStatus(false, filterContainer);
        }
        else if (!isConversationMode(mc) && !this.filterStatusEnable) {
            this.filterStatusEnable = true;
            this.setFilterStatus(true, filterContainer);
        }
    };

    ConnectionsLogTableViewController.prototype.getConfiguration = function () {
        var modelController = this.getModelControllerInstance();
        this.isManagerViewMode = modelController.isManagerViewMode;
        this.hasViewOtherConvPrivilege = modelController.hasViewOtherConvPrivilege;


        var configuration = {
            updateQueryCallback: modelController.updateQuery,
            context: this,
            textsPrefix: this.LPPrefixMap.connectionsLog,
            tableName: this.applicationType,
            tableRootModelPath: "connectionsLogs",
            globalData: {
                modelController: modelController,
                tableName: this.applicationType,
                textsPrefix: this.LPPrefixMap.connectionsLog
            },
            tableHead: {
                headerRowClassName: this.isManagerViewMode ? this.LPClassesMap.manager : this.LPClassesMap.agent,
                columnsData: getColumnsData.apply(this)
            },
            tableBody: {
                htmlTable: true,
                ignoreRowHover: true,
                ignoreSectionHover: true,
                rowTemplateFile: this.isManagerViewMode ? 'LP_connections_log_table_row_manager.html' : 'LP_connections_log_table_row_agent.html',
                dataRenderer: this.dataRenderer,
                dataBinder: this.dataBinder,
                supportKeysNavigation: true
            },
            paging: {
                pageSize: this.getModelControllerInstance().getDefaultValue("limit"),
                hidePagingText: false
            },
            widgets: {
                widgetsManager: ConnectionsLogListWidgetsManager,
                widgetsManagerData: {
                    className: "app_connections_widgets",
                    autoHideButtonsToolbar: false,
                    itemIdTag: "chatInfo.chatId",
                    widgetsData: [
                        {
                            widgetType: ConnectionsLogEngagementWidget,
                            widgetData: {
                                itemIdTag: "chatInfo.chatId",
                                chatsRootModelPath: 'connectionsLogs.data',
                                widgetMode: "History",
                                engagementType: lpTag.WebAgent.logicController.engagementTypes.asyncMessaging
                            }
                        },
                        {
                            widgetType: ConnectionsLogConsumerInfoWidget,
                            widgetData: {
                                itemIdTag: "chatInfo.chatId",
                                visitorInfoPath: "visitorInfo",
                                rootModelPath: 'connectionsLogs.data',
                                search:false
                                // useDataInPath: false,
                                // chatsRootModelPath: 'connectionsLogs.data',
                                // chatIdPath: "chatInfo.chatId"
                            }
                        }
                    ]
                }
            },
            tableFilters: getFilters.call(this, modelController),
            filterStatusEnable: true
        };
        configuration.tableSearch = {
            actionType: "filter", //activating filtering in the search box
            filterItems: this.getFilterSearchItems(),
            filterDefaultSelection: this.getFilterSearchDefaultItems(),
            LPSearchFilterOptions: this.LPSearchFilterOptions,
            iconId: 99, //TODO take from someplace?
            afterTitle: "",
            searchFilterEventCallback: true, //fire a special event and not the default filter event
            alphaOption: this.LPSearchFilterOptions.CHATID.id //send this if there is an option that should disable all others if it's selected
        };
        if(lpTag.WebAgent.logicController.canGenerateSecureFormToken()) {
            configuration.tableActions = {
                actionDropdownArray: [
                    {
                        id: "searchOnToken",
                        actionName: this.translate("CONNECTIONS_LOG_action_allConnectionsSearchOnToken"),
                        title: this.translate("CONNECTIONS_LOG_action_allConnectionsSearchOnTokenTooltip"),
                        enabled: true,
                        align: "right",
                        callbackFunc: _.bind(this.openSearchOnTokenDialog, this)
                    }]
            };
            configuration.tableGenerateToken = {
                templateFile: 'LP_generate_token_search_dialog.html'
            };
        }
        if (!lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
            configuration.tableHead.headerRowClassName += " hide_agentGroups";
        }
        if (!this.isManagerViewMode && !this.hasViewOtherConvPrivilege) {
            configuration.tableHead.headerRowClassName += " hide_agentName";
        }
        return configuration;

    };

    ConnectionsLogTableViewController.prototype.openSearchOnTokenDialog =  function() {
        if (!this.tableGenerateToken.visible) {
            this.tableGenerateToken.showDialog();
        }
    };

    //return an object that contains the search itmes by id and text
    ConnectionsLogTableViewController.prototype.getFilterSearchItems = function () {
        var resultArray = [];


        /**
         * Currently the UMS not supporting Encryption.
         * to enable the feature detection use: lpTag.WebAgent.agentLEManager.hasDataEncryptionFeature();
         */
        var isEncrypted = false;


        for (var option in this.LPSearchFilterOptions) {
            if (this.LPSearchFilterOptions.hasOwnProperty(option)) {
                var obj = this.LPSearchFilterOptions[option];
                if (obj.id && obj.text) {
                    if (!isEncrypted || (isEncrypted && obj.id !== this.LPSearchFilterOptions.TRANSCRIPT.id)) {
                        resultArray.push({"id": obj.id, "text": this.translate(obj.text)});
                    }
                } else if (obj.id === this.LPSearchFilterOptions.SEPARATOR.id) {
                    resultArray.push({"id": "separator", "text": ""});
                }
            }
        }
        return resultArray;
    };

    ConnectionsLogTableViewController.prototype.getFilterSearchDefaultItems = function () {
        /**
         * Currently the UMS not supporting Encryption.
         * to enable the feature detection use: lpTag.WebAgent.agentLEManager.hasDataEncryptionFeature();
         */
        var isEncrypted = false;
        if (isEncrypted) {
            return (this.LPSearchFilterOptions.CHATID.id);
        } else {
            return this.LPSearchFilterOptions.TRANSCRIPT.id;
        }
    };

    ConnectionsLogTableViewController.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return 1;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length;
        },
        dataForSection: function (data, sectionIndex) {

        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var self = this,
                value = {};

            if (data && data.length) {
                var chatInfo = data[rowIndex].chatInfo || {};
                var visitorInfo = data[rowIndex].visitorInfo || {};
                var agentInfo = data[rowIndex].agentInfo || data[rowIndex].suggestedAgentInfo || {};
                var naMessage = this.translate(self.translationTexts.NOT_AVAILABLE);

                var participantSerialNumber, participantTag;
                if (visitorInfo.visitorId && lpTag.WebAgent.logicController.isAcceptedEngagement(visitorInfo.visitorId)) {
                    var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorInfo.userId);
                    participantSerialNumber = self.getModelParam(participantPath + '.participantInfo.visitorSerialNumber');
                    participantTag = self.getModelParam(participantPath + '.participantTag');
                }

                _.assign(value, MessagingUtils.getStateValues(chatInfo.messagingState, chatInfo.mainDialogCloseReason));
                _.assign(value, MessagingUtils.getBadgesValues(chatInfo.badges, chatInfo.messagingState));
                _.assign(value, MessagingUtils.getConsumerInfo(visitorInfo.visitorName, null, visitorInfo.imgUrl, true));
                _.assign(value, MessagingUtils.getParticipantInfo(participantSerialNumber, participantTag));
                _.assign(value, MessagingUtils.getUnreadMessagesValues(agentInfo && agentInfo.loggedInAgentUnreadCount));

                if (!_.isUndefined(chatInfo.duration)) {
                    var engLengthTexts = lpTag.WebAgent.logicController.getFormatDurationTime(chatInfo.duration);
                    value.engLength = engLengthTexts.text;
                    value.engLengthTooltip = engLengthTexts.tooltip;
                }

                value.id = chatInfo && chatInfo.chatId;
                value.startTime = lpUtils.formatDateAsString(new Date(chatInfo.startTime)) || naMessage;
                value.skillTooltip = value.skill = chatInfo.skillName || naMessage;
                value.nameTooltip = value.name;
                value.sentimentTooltip = value.mcs = isNaN(chatInfo.mcs) ? naMessage : chatInfo.mcs;
                value.alertedMCS = chatInfo.alertedMCS;
                // value.sentiment = lpTag.WebAgent.logicController.getSentimentTag(chatInfo.alertedMCS);
                var slaTexts = chatInfo.responseTime && chatInfo.responseTime.slaTexts;
                value.SLA = slaTexts && slaTexts.text || '';
                value.SLATooltip = slaTexts && slaTexts.tooltip || '';
                value.almostOverdue = slaTexts && (slaTexts.almostOverdue || (chatInfo.badges && chatInfo.badges.overdue)) ? 'almost_overdue' : '';


                if (value.sentiment === "neutral" ){
                    value.sentimentIconTooltip = '';
                } else {
                    value.sentimentIconTooltip = agentLEManager.translateLE('LEWebAgent.' + 'SENTIMENT_' + value.sentiment);
                }
                value.lastMessageTime = (chatInfo.lastMainDialogMessage && chatInfo.lastMainDialogMessage.time && chatInfo.lastMainDialogMessage.time > 0) ? lpUtils.formatDateAsString(new Date(chatInfo.lastMainDialogMessage.time)) : naMessage;


                value.lastMessageTimeTooltip = '';
                if (chatInfo.lastMainDialogMessage) {
                    value.lastMessageTimeTooltip = MessagingUtils.formatLastMessage(chatInfo.lastMainDialogMessage).formattedMessageTextTooltip;
                }

                value.darkLine = rowIndex % 2 === 0 ? 'dark_line' : '';

                if (this.isManagerViewMode || this.hasViewOtherConvPrivilege) {
                    value.agentNameTooltip = value.agentName = (agentInfo && agentInfo.agentName) || naMessage;
                    value.agentDeleted = (agentInfo && agentInfo.agentDeleted) ? this.translate('agent_deleted_indication') + ' ' : '';
                    value.suggestedAgentClassName = '';
                    if (agentInfo.agentState === lpTag.AMSStatics.assignedAgentState.SUGGESTED) {
                        value.suggestedAgentClassName = 'suggested_agent';
                        value.agentNameTooltip = this.translate('transferredToAgent') + value.agentName;
                    } else if (lpTag.WebAgent.logicController.hasTransferToAgentFeatureEnabled() && value.agentName !== naMessage) {
                        value.agentNameTooltip = this.translate('assignedToAgent') + value.agentName;
                    }
                    // else- leave as assigned name or N/A
                    if (this.isManagerViewMode) {
                        value.agentGroupTooltip = value.agentGroupName = (agentInfo && agentInfo.agentGroupName) || naMessage;
                        if (!lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
                            value.className += " hide_agentGroups";
                        }
                    }
                } else {
                    value.className += " hide_agentName";
                }

                var metaData = self.getModelParam(this.modelController.getModelPaths().metadata + "." + chatInfo.chatId);

                if (metaData) {
                    var pastAssignedAgentNames = metaData.agentNames;
                    if ((this.isManagerViewMode || this.hasViewOtherConvPrivilege) && !!value.suggestedAgentClassName) {
                        pastAssignedAgentNames = _.without(metaData.agentNames, _.find(metaData.agentNames, { id: agentInfo.agentId }));
                    }

                    var agentLength = pastAssignedAgentNames.length;
                    value.pastAssignedAgentNamesVisible = (agentLength > 0) ? "" : "hidden";
                    value.pastAssignedAgentNamesCount = agentLength;
                    value.pastAssignedAgentNamesTooltip = (agentLength > 0) ? getItemsNameAsStr(pastAssignedAgentNames) : "";

                    var pastAssignedAgentGroups = metaData.agentGroups;
                    var agentGroupLength = pastAssignedAgentGroups.length;
                    value.pastAssignedAgentGroupsVisible = (agentGroupLength > 0) ? "" : "hidden";
                    value.pastAssignedAgentGroupsCount = agentGroupLength;
                    value.pastAssignedAgentGroupsTooltip = (agentGroupLength > 0) ? getItemsNameAsStr(pastAssignedAgentGroups) : "";

                    var pastAssignedSkills = metaData.skills;
                    var skillsLength = pastAssignedSkills.length;
                    value.pastAssignedSkillsVisible = (skillsLength > 0) ? "" : "hidden";
                    value.pastAssignedSkillsCount = skillsLength;
                    value.pastAssignedSkillsTooltip = (skillsLength > 0) ? getItemsNameAsStr(pastAssignedSkills) : "";
                }
            }

            return value;
        }
    };

    ConnectionsLogTableViewController.prototype.dataBinder = {
        modelDataChanged: function () {
            // this will keep the manager widget open if the same object id will be in the next results.
            if (this.widgetsManager) {
                var dataPath = this.modelController.getModelPaths().data;
                var selectedItemId = this.widgetsManager.selectedItemId;
                var selectedItem = this.modelController.getModelParam(dataPath + '.' + selectedItemId);
                if (!selectedItem) {
                    this.widgetsManager.closeWidgetsArea();
                }
            }
        },
        operationCanceled: BaseTableViewController.prototype.baseTableBodyDataBinder.operationCanceled,
        rowSelected: function (data) {
            this.modelController.setSelectedItem(this.widgetsManager.selectedItemId);
            return BaseTableViewController.prototype.baseTableBodyDataBinder.rowSelected.apply(this, arguments);
        },
        rowClicked: function (data, view, event) {
            // link clicked.
            var chatId = data.rowData.chatInfo.chatId;
            var target = event && (event.target || event.srcElement);
            var consumerLink = this.getFirstElement(this.LPViewMap.consumerLink, view);
            var isValidLink = this.hasSingleClass(consumerLink, 'bluelink');
            if (consumerLink && target === consumerLink && isValidLink) {
                this.modelController.openEngagement({chatId: chatId});
                return false; // don't bubble the event.
            }
            return BaseTableViewController.prototype.baseTableBodyDataBinder.rowClicked.apply(this, arguments);
        }
    };


    /**
     *
     * @param mc - model controller
     * @returns {boolean} - true - if the searchTag is empty and also the searchArea is "chatId", false - otherwise
     */
    function isConversationMode(mc) {
        return ( (mc.getModelParam(mc.getModelPaths().lastQuery + ".searchArea") === "chatId") && (mc.getModelParam(mc.getModelPaths().lastQuery + ".searchTag") !== "") );
    }

    function getItemsNameAsStr(pastAssignedItem) { //gets array of objects and return str of the items name separated with <br/>
        return pastAssignedItem.map(function (item) {
            return item.name;
        }).join("<br/>");
    }

    function getColumnsData() {

        var columns = [
            { //c1
                // sortTag: "status",
                title: "conversationStatus",
                tooltip: this.LPPrefixMap.connectionsLog + ".conversationStatusTooltip",
                tooltipAlign: "left"
            },
            { //c2
                sortTag: "responseTime",
                title: "SLA",
                tooltip: "SLATooltip"
            },
            { //c2
                visitorImage: "visitorImage" //show no title
            },
            { //c3
                title: "consumerName"
            },
            { //c4
                // sortTag:"skillIds",
                title: "skill",
                tooltip: this.LPPrefixMap.connectionsLog + ".skillTooltip"
            },
            {
                // sortTag: 'agentIds',
                title: "pastChatAgentName",
                tooltip: this.LPPrefixMap.connectionsLog + ".pastChatAgentNameTooltipMultiValue"
            },
            { //c7
                mcsImage: "mcsImage" // show no title
            },
            { //c8
                title : "filter_title_mcs",
                tooltip : "sentimentTooltip"
            },
            { //c9
                sortTag: "start",
                title: "CONVERSATION_START_TIME",
                tooltip: this.LPPrefixMap.connectionsLog + ".chatStartTooltip",
                tooltipAlign: "left"
            },
            { //c10
                title: "LAST_MESSAGE_TIME",
                tooltip: this.LPPrefixMap.connectionsLog + ".lastMessageTimeTooltip"
            },
            { //c11
                // sortTag : "duration",
                title: "duration",
                tooltip: this.LPPrefixMap.connectionsLog + ".engLengthTooltip"
            }
        ];

        if (this.isManagerViewMode) { //c6
            var columeConfiguration = {visitorImage: "visitorImage"};
            if (lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
                columeConfiguration = {
                    // sortTag: 'agentGroupIds',
                    title: "activeChatAgentGroup",
                    tooltip: this.LPPrefixMap.connectionsLog + ".activeChatAgentGroupTooltipMultiValue"
                };
            }
            columns.splice(6, 0, columeConfiguration);
        }

        return columns;
    }

    function getFilters(modelController) {
        var activeFilters = {
            filterName: "filters"
        };

        activeFilters.Status = {
            text: "history_search_filter_status",
            tooltip: this.LPPrefixMap.connectionsLog + ".conversationStatusTooltip",
            name: "status",
            type: "multiSelect",
            filterTextSuffix: "status",
            items: [
                {
                    id: "OPEN",
                    name: this.translate(this.translationTexts.StatusFilterStateOpen)
                },
                {
                    id: "CLOSE",
                    name: this.translate(this.translationTexts.StatusFilterStateClose)
                }
                // ,
                // {
                //     id: "LOCKED",
                //     name: this.translate(this.translationTexts.StatusFilterStateLocked)
                // }
            ]
        };

        activeFilters.inQueue = {
            tooltip: "",
            name: "latestConversationQueueState",
            type: "singleCheckBox",
            value: "IN_QUEUE",
            textValue: this.translate(this.translationTexts.conversationInQueueFilter)
        };

        // activeFilters.inQueue = {
        //     tooltip: "",
        //     name: "latestConversationQueueState",
        //     type: "checkBoxMoreOptionsWhenChecked",
        //     isChecked: false,
        //     defaultSelected: "all",
        //     optionButtons: [
        //         {
        //             buttonId: "all",
        //             content: agentLEManager.translateLE("LEWebAgent.all")
        //         },
        //         {
        //             buttonId: "transfer",
        //             content: "Transferred to agent"//TODO: add translation
        //         }
        //     ],
        //     shouldDisplayOptions: lpTag.WebAgent.logicController.getAgentMessagingTransferToAgentPermissions(),
        //     textValue: this.translate(this.translationTexts.conversationInQueueFilter)
        // };

        activeFilters.StartTime = {
            text: "history_search_filter_start_time",
            tooltip: this.LPPrefixMap.connectionsLog + ".chatStartTooltip",
            name: "start",
            type: "timeFrame",
            defaultFilter: {
                startDate: modelController.getDefaultValue("filters.start.from"),
                endDate: modelController.getDefaultValue("filters.start.to")
            },
            maxMonthsDuration: 3
        };

        activeFilters.responseTime = {
            text: "history_search_filter_response_time",
            name: "responseTime",
            tooltip: "SLATooltip",
            dataPersonalization: 'responseTime',
            type: "slaDuration",
            constantWidth: true,
            availableDurationUnits: [
                DurationInputViewController.DURATION_UNITS.minutes,
                DurationInputViewController.DURATION_UNITS.hours,
                DurationInputViewController.DURATION_UNITS.days
            ],
            longerThanRange: { max: 999999, min: -999999 },
            shorterThanRange: { max: 999999, min: -999999 },
            defaultFilter: {
                comparisonMethod: DurationInputViewController.COMPARISON_OPTIONS.between,
                longerThan: undefined,
                shorterThan: undefined,
                durationUnit: DurationInputViewController.DURATION_UNITS.minutes
            }
        };

        activeFilters.Skill = {
            text: "history_search_filter_skill",
            tooltip: this.LPPrefixMap.connectionsLog + ".skillTooltip",
            name: "skillIds",
            type: "multiSelectWithSearch",
            floating: true,
            minusOneData: {"id": -1, "displayName": this.translate(this.translationTexts.unassigned) , "name" : this.translate(this.translationTexts.unassigned)},
            filterTextSuffix: "skills",
            filterDataModelPath: 'skills.array'
        };

        if (this.isManagerViewMode) {

            activeFilters.AgentGroup = {
                text: "history_search_filter_agent_group",
                tooltip: this.LPPrefixMap.connectionsLog + ".activeChatAgentGroupTooltipMultiValue",
                name: "agentGroupIds",
                type: "multiSelectWithSearch",
                floating: true,
                textProperty: "displayName",
                filterTextSuffix: "agentGroups",
                filterDataModelPath: 'agent.agentGroups.array'
            };

        }

        if (this.isManagerViewMode || this.hasViewOtherConvPrivilege) {

            activeFilters.AgentName = {
                text: "history_search_filter_agent_name",
                tooltip: this.LPPrefixMap.connectionsLog + ".pastChatAgentNameTooltipMultiValue",
                name: "agentIds",
                type: "multiSelectWithSearch",
                textProperty: "displayName",
                floating: true,
                toggleButton: agentLEManager.getLEConfig().supportDeletedUsers && {
                    toggleByField: {
                        fieldName: 'deleted',
                        lineSubText: this.translate('filter_deleted_indication'),
                    },
                    checked: false
                },
                label: agentLEManager.getLEConfig().supportDeletedUsers && this.translate('filter_deleted_agents_title'),
                // there is a bug in the backend that cannot filter unassigned agents.
                //minusOneData: {"id": -1, "displayName": this.translate(this.translationTexts.unassigned)},
                filterTextSuffix: "agents",
                filterDataModelPath: modelController.getModelPaths().agentNames
            };

        }

        activeFilters.MCS = {
            text: "history_search_filter_agent_MCS",
            name: "mcs",
            type: "mcs",
            tooltip: this.LPPrefixMap.connectionsLog + ".sentimentTooltip"
        };
        if (!LE.sessionManager.hasMessagingSurveyFeature() || !LEConfig.postConvSurveyFilter) {
            activeFilters.Csat = {
                text: "history_search_filter_agent_Csat",
                name: "csat",
                type: "dropdownNumericRange",
                tooltip: this.LPPrefixMap.connectionsLog + ".csatTooltip",
                startMinValue: 1,
                startMaxValue: 5,
                endMinValue: 1,
                endMaxValue: 5,
                validateable: true
            };
        }

        activeFilters.Duration = {
            text: "history_search_filter_duration",
            name: "duration",
            tooltip: this.LPPrefixMap.connectionsLog + ".engLengthTooltip",
            type: "numericRange",
            units: [
                {text: this.translate('filter_duration_unit_seconds'), type: "seconds"},
                {text: this.translate('filter_duration_unit_minutes'), type: "minutes"},
                {text: this.translate('filter_duration_unit_hours'), type: "hours"},
                {text: this.translate('filter_duration_unit_days'), type: "days"}
            ],
            startMinValue: 0,
            endMinValue: 0
        };

        activeFilters.Summary = {
            text: "history_search_filter_conversation_summary",
            name: "summary",
            tooltip: this.LPPrefixMap.connectionsLog + ".conversation_summary",
            type: "textBoxInput"
        };

        activeFilters.EngagementAttributes = {
            text: "history_search_filter_engagement_attributes",
            name: "sdeSearch",
            type: "textBoxInput",
            tooltip: this.LPPrefixMap.connectionsLog + ".engagement_attributes"
        };

        if (LE.sessionManager.hasMessagingSurveyFeature() && privilegesController.hasViewMessagingSurveysPrivilege() && LEConfig.postConvSurveyFilter) {

            activeFilters.SurveyAttributes = {
                tooltip: "",
                name: "surveyAttributes",
                type: "collapsible",
                value: "SURVEY_ATTRIBUTES",
                text: "history_search_filter_survey_attributes",
                collapseFilterItems: ["surveyBotConversations", "surveyIds", "questionBrick", "csat", "nps", "fcr", "invalidFreeTextAnswer", "questionTypeAndFormatToRetrieve", "answerText"]
            };

            activeFilters.SurveyBotConv = {
                tooltip: "",
                name: "surveyBotConversations",
                type: "singleCheckBox",
                value: "SURVEY_BOT",
                textValue: this.translate(this.translationTexts.history_search_filter_survey_bot_conversations),
                hideTableRowOnLoad: true,
                alignLeft: true
            };

                activeFilters.SurveyNameId = {
                text: "history_search_filter_survey",
                tooltip: this.LPPrefixMap.connectionsLog + ".surveyNameIdTooltip",
                name: "surveyIds",
                type: "surveyNameId",
                textProperty: "name",
                floating: true,
                filterTextSuffix: "selectSurvey",
                filterDataModelPath: 'postSurvey.array',
                idPlaceHolderText: this.translate(this.translationTexts.history_search_filter_survey_enter_id),
                hideTableRowOnLoad: true
            };

            activeFilters.QuestionBrick = {
                text: "history_search_filter_question_brick",
                name: "questionBrick",
                tooltip: "",
                type: "textBoxInput",
                item_placeholder: this.translate("history_search_filter_question_brick_name_or_id"),
                hideTableRowOnLoad: true
            };

            activeFilters.Csat = {
                text: "history_search_filter_agent_Csat",
                name: "csat",
                type: "dropdownNumericRange",
                tooltip: this.LPPrefixMap.connectionsLog + ".csatPCSTooltip",
                startMinValue: 1,
                startMaxValue: 5,
                endMinValue: 1,
                endMaxValue: 5,
                hideTableRowOnLoad: true,
                validateable: true
            };

            activeFilters.Nps = {
                text: "history_search_filter_nps",
                name: "nps",
                type: "dropdownNumericRange",
                tooltip: this.LPPrefixMap.connectionsLog + ".npsTooltip",
                startMinValue: 0,
                startMaxValue: 10,
                endMinValue: 0,
                endMaxValue: 10,
                hideTableRowOnLoad: true,
                validateable: true
            };

            activeFilters.Fcr = {
                name: "fcr",
                type: "yesNoCheckBox",
                tooltip: this.LPPrefixMap.connectionsLog + ".fcrTooltip",
                value: "HISTORY_SEARCH_FILTER_FCR",
                text: "history_search_filter_fcr",
                textValue1: this.translate("history_search_filter_fcr_yes"),
                value1: "yes",
                textValue2: this.translate("history_search_filter_fcr_no"),
                value2: "no",
                valueBoth: "yes,no",
                hideTableRowOnLoad: true
            };

            if (LEConfig.postConvSurveyFilterInvalidFreeText) {
                activeFilters.InvalidFreeTextAnswer = {
                    tooltip: "",
                    name: "invalidFreeTextAnswer",
                    type: "singleCheckBox",
                    value: "INVALID_FREE_TEXT_ANSWER",
                    textValue: this.translate(this.translationTexts.history_search_filter_invalid_free_text_answer),
                    hideTableRowOnLoad: true,
                    alignLeft: true
                };
            }

            if (LEConfig.postConvSurveyFilterOpenText) {
                activeFilters.OpenQuestionAnswered = {
                    tooltip: "",
                    name: "questionTypeAndFormatToRetrieve",
                    type: "singleCheckBox",
                    value: "OPEN_QUESTION_ANSWERED",
                    textValue: this.translate(this.translationTexts.history_search_filter_open_question_answered),
                    hideTableRowOnLoad: true,
                    filterItemToEnableWhenChecked: "answerText",
                    alignLeft: true
                };

                activeFilters.SurveyAnswer = {
                    name: "answerText",
                    type: "multiText",
                    tooltip: this.LPPrefixMap.connectionsLog + ".freeTextAnswerTooltip",
                    text: "history_search_filter_free_text_answer",
                    tagsContainerEnabled: false,
                    hideTableRowOnLoad: true,
                    separator: this.translate("history_search_filter_free_text_answer_separator"),
                    maxShownLines: 3
                };
            }
        }

        return activeFilters;
    }

    // todo - lose the global variable
    window.ConnectionsLogTableViewController = ConnectionsLogTableViewController;

    return ConnectionsLogTableViewController;

});
